import { render } from "./KdgAdminNotifications.vue?vue&type=template&id=6d4ccec9&scoped=true&ts=true"
import script from "./KdgAdminNotifications.vue?vue&type=script&lang=ts"
export * from "./KdgAdminNotifications.vue?vue&type=script&lang=ts"

import "./KdgAdminNotifications.vue?vue&type=style&index=0&id=6d4ccec9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4ccec9"]])

export default __exports__